<template>
  <div>
    <div class="d-none d-md-block mb-4">
        <button class="btn --theme-primary --style-xsmall" @click="deleteAll">Delete All</button>
        <button class="btn --theme-primary --style-xsmall" @click="deleteSelected">Delete Selected</button>
        <button class="btn --theme-primary --style-xsmall">Export Regenerate Links</button>
        <button class="btn --theme-primary --style-xsmall" @click="exportSelected">Export Selected</button>
        <button class="btn --theme-dblue --style-xsmall float-right"  @click="selectAll" v-model="allSelected">Select All</button>
    </div>
    <div class="d-block d-md-none">
       <div class="row">
          <div class="col-8">
             <div class="form-group">
                <div class="control-select fixedWidth">
                   <span style="user-select: none;">Select Actions</span>
                   <select class="js-payment-length">
                      <option>Select Actions</option>
                      <option id="dad">Delete All</option>
                      <option id="dsd">Delete Selected</option>
                      <option id="egd">Export Regenerate Links</option>
                      <option id="esd">Export Selected</option>
                   </select>
                </div>
             </div>
          </div>
          <div class="col-4 pl-0">
            <a href="#" class="js-checkall btn --theme-dblue --style-block"  @click="selectAll" v-model="allSelected">Select All</a>
          </div>
       </div>
    </div>
    <div class="row" v-if="typeof(transfers_finished.length) === 'undefined'">
        <div class="col-md-12 p-2 text-center">
          <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
    </div>
    <div class="row grid-flex --style-auto +offset-bottom js-download-grid-toggle" v-else-if="transfers_finished.length && listing_type == 'GRID'">
      <div class="col-12">
         <flash message="" class="mb-4 pl-4"></flash>
      </div>
       <div class="col-sm-6 my-2 grid-item" v-for="(transfer, index) in transfers_finished">
          <div :id="transfer.id"  class="box-download">
             <div class="box-download__logo"><i class="icon icon-type-torrent"></i></div>
             <div class="box-download__content">
                <p><small> Downloaded from <strong>Torrent</strong></small></p>
                <p>
                  <a v-bind:href="'/my-downloads/files?id=' + transfer.file_id" class="box-download__link text-break" v-if="transfer.file_id !== null">{{ transfer.name }}</a>
                  <a v-bind:href="'/my-downloads/files?folder_id=' + transfer.folder_id" class="box-download__link text-break" v-else>{{ transfer.name }}</a>
                </p>
             </div>
             <div class="box-download__actions">
                <ul class="clearfix">
                   <li class="float-left">
                    <span v-if="transfer.file_id !== null">
                      <a v-bind:href="'/my-downloads/file?id=' + transfer.file_id" class="+fc-green +fw-black"><i class="icon icon-play"></i>Play</a>
                      <a class="dllink +fc-green +fw-black  ml-2"><i class="icon icon-download-alt"></i>Download</a>
                    </span>
                    <span v-else>
                      <a v-bind:href="'/my-downloads/files?folder_id=' + transfer.folder_id" class="+fc-green +fw-black"><i class="icon icon-folder"></i>Directory</a>
                      <a href="javascript:void(0);" @click="zipTransfer($event,index,transfer.folder_id)" :id="'dl_'+index" class="dllink +fc-green +fw-black ml-2"><i class="icon icon-download-alt"></i>Download</a></span>
                    </span>
                  </li>
                   <li class="float-right">
                      <div class="control-group__control">
                         <div class="control-checkbox"><label>
                          <input type="checkbox"  v-model="items_selected" @click="select(transfer.id)" :value="transfer">
                          <span class="control-checkbox__checkbox"><i></i></span><span class="control-checkbox__text"></span></label></div>
                      </div>
                   </li>
                   <li class="float-right">
                      <a href="#" class="dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">Actions <i class="fa fa-caret-down" aria-hidden="true"></i></a>
                      <ul class="dropdown-menu">
                         <li><a class="dropdown-item" href="javascript:void(0);" @click="viewSource(transfer.src)"><i class="fas fa-magnet"></i> Source</a></li>
                        
                         <li><a  href="javascript:void(0);"  @click="deleteTransfer($event,index,transfer.id)" v-bind:id="'delete_'+transfer.id" class="dropdown-item"><i class="fas fa-trash"></i> Delete</a></li>
                      </ul>
                   </li>
                </ul>
             </div>
          </div>
       </div>
    </div>
    <div class="row" v-else-if="transfers_all.length && listing_type == 'TABLE'">
      <div class="col-12">
        <table>
          <thead>
            <tr>
              <th scope="col">Name</th>
              <th scope="col">Size</th>
              <th scope="col">Original</th>
              <th scope="col">Progress</th>
              <th scope="col">Status</th>
              <th scope="col">Download</th>
              <!-- <th scope="col">Re-Bind</th> -->
              <th scope="col">Delete</th>
              <th scope="col">Select All</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(transfer, index) in transfers_all">
              <td>
                <p class="mb-0">
                  <a v-bind:href="'/my-downloads/files?id=' + transfer.file_id" class="text-break" v-if="transfer.file_id !== null">{{ transfer.name }}</a>
                  <a v-bind:href="'/my-downloads/files?folder_id=' + transfer.folder_id" class="text-break" v-else>{{ transfer.name }}</a>
                </p>
              </td>
              <td></td>
              <td>
                <a href="javascript:void(0);" @click="viewSource(transfer.src)">Source</a>
              </td>
              <td>
                <span v-if="transfer.status == 'finished'">
                  100% (0 KB/s | 0 KB/s)  
                </span>
                <span v-else>
                  {{ transfer.progress * 100 }} % ({{ transfer.message.split(',')[0] }})
                </span>
              </td>
              <td>
                <span v-if="transfer.status == 'finished'">Complete</span>
                <span v-else-if="transfer.status == 'running'">Downloading</span>
                <span v-else-if="transfer.status == 'queued'">Queued</span>
                <span v-else>Error</span>
              </td>
              
              <td>
                <span v-if="transfer.status == 'finished'">
                  <a href="javascript:void(0);" @click="zipTransfer($event,index,transfer.folder_id)">Download</a>
                </span>
                <span v-else>
                  Waiting
                </span>
              </td>
             <!--  <td></td> -->
              <td>
                <a href="javascript:void(0);" class="text-danger" @click="deleteTransfer($event,index,transfer.id)" >Delete</a>
              </td>
              <td>
                
                    <input type="checkbox"  v-model="items_selected" @click="select(transfer.id)" :value="transfer">
                    
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Modals -->
    <div class="modal fade" id="sourceModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
       <div class="modal-dialog" role="document">
          <div class="modal-content">
             <div class="modal-header">Source</div>
             <div class="modal-body text-center">
                <div class="row pmcard-row">
                   <div class="col-md-12"><textarea rows="5" class="directlinks form-control" id="source" style="white-space: pre;">{{ src }}</textarea></div>
                </div>
             </div>
             <div class="modal-footer">
              <button type="button" class="btn btn-secondary --style-xsmall" data-dismiss="modal">Close</button>
              <button type="button" class="btn btn-primary --style-xsmall" data-dismiss="modal" @click="copyToClipboard(selected_item.src)">Copy Links</button>
             </div>
          </div>
       </div>
    </div>
  </div>
</template>
 
<script>
  export default {
      props: ['message','premium'],
      data() {
          return {
            folder_id: this.getParameterFromUrl('folder_id'),
            transfers_finished: {},
            transfers_running: {},
            transfers_queued: {},
            transfers_error: {},
            transfers_all: {},
            items: {},
            selected: [],
            allSelected: false,
            items_selected: [],
            selected_item: {},
            src: null,
            listing_type: null
          }
      },
      mounted() {
          this.list();

          if(localStorage.listing_type && localStorage.listing_type == 'GRID'){
            this.listing_type = 'GRID';
          } else {
            this.listing_type = 'TABLE';
          }
      },
      methods: {
        list(){
          axios.get('/api/transfers/list').then( response=> {
                this.transfers_finished =response.data.transfers_list.finished;
                this.transfers_running = response.data.transfers_list.running;
                this.transfers_queued = response.data.transfers_list.queued;
                this.transfers_error = response.data.transfers_list.error;
                this.transfers_all = response.data.transfers_list.all;

                var clear = true;
                for(var i = 0; i < this.transfers_running.length; i++) {
                 
                  if(this.transfers_running[i].status == 'running') {

                      clear = false; 
                      break;
                  }
                }

                for(var i = 0; i < this.transfers_queued.length; i++) {
                  if(this.transfers_queued[i].status == 'queued') {
                      clear = false; 
                      break;
                  }
                }
                
                if(clear) {
                    clearInterval(this.interval);
                }

            }).catch(error=>{
                flash(JSON.parse(error.request.response).message, 'error');
            })
        },
        updateList(){
          clearInterval(this.interval);
          this.interval = setInterval(this.list, 1000);
        },
        getParameterFromUrl: function(param){
            var result = null,
              tmp = [];
            var items = location.search.substr(1).split("&");
            for (var index = 0; index < items.length; index++) {
              tmp = items[index].split("=");
              if (tmp[0] === param) result = decodeURIComponent(tmp[1]);
            }
            return result
        },
        diveUpToFolder(id) {
          if(id == null){
            window.history.pushState({}, document.title, "/my-downloads");
            this.handleRefresh();
          } else {
             window.history.pushState({}, document.title, "/my-downloads?folder_id=" + id);
            this.handleRefresh();
          }
        },
        handleRefresh(){

          this.transfers_finished = {};
          this.transfers_running = {};
          this.transfers_queued = {};
          this.transfers_error = {};
          this.transfers_all = {};
          this.items = {};
          this.selected = [];
          this.allSelected= false;
          this.items_selected = [];
          this.selected_item = {};
          this.src = null;
          this.folder_id = this.getParameterFromUrl('folder_id');
          this.list();
        },
        selectAll: function() {
            this.allSelected = !this.allSelected; 

            this.items_selected = [];               
            if (this.allSelected) {
                for(var i = 0; i < this.transfers_all.length; i++) {
                    $('#'+this.transfers_all[i].id).addClass("--checked");
                    this.items_selected.push(this.transfers_all[i]); 
                }

            } else {
              $(".box-download").removeClass('--checked');
            }


           
        },
        select: function(id) {
            $('#'+id).toggleClass("--checked");
            this.allSelected = false;
        },
        viewSource(src) {
          this.src = src;
          $('#sourceModal').modal('toggle');
        },
        copyToClipboard: function(text) {
          if (window.clipboardData && window.clipboardData.setData) {
            // IE specific code path to prevent textarea being shown while dialog is visible.
            return clipboardData.setData("Text", text);

          } else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
            var textarea = document.createElement('textarea');
            textarea.textContent = text;
            document.body.appendChild(textarea);
            var selection = document.getSelection();
            var range = document.createRange();
            range.selectNode(textarea);
            selection.removeAllRanges();
            selection.addRange(range);
            try {
              return document.execCommand("copy"); // Security exception may be thrown by some browsers.
            } catch (ex) {
              console.warn("Copy to clipboard failed.", ex);
              return false;
            } finally {
              selection.removeAllRanges();
              document.body.removeChild(textarea);
            }
          }
        },
        zipTransfer(e,index,folder_id) {
          axios.post('api/zip/generate',{'folder_ids': [folder_id]}).then(response=>{
              window.location.href = response.data.location;
            }).catch(error=>{
              flash(JSON.parse(error.request.response).message, 'error');
          });
        },
        exportSelected(){

          var src = [];
          for(var i = 0; i < this.items_selected.length; i++) {
            src.push(this.items_selected[i].src);
          }

          this.src = src.join('\n');
          $('#sourceModal').modal('toggle');
        },
        deleteAll(){

          var finished = 0;
          for(var i = 0; i < this.transfers_finished.length; i++) {
            axios.delete('/api/transfers/delete/'+this.transfers_finished[i].id).then(response=>{
                finished++;
                console.log(finished);
            }).catch(error=>{
                finished++;
                flash(JSON.parse(error.request.response).message, 'error');
            });
          }

          if(finished == this.items_selected.length){
            flash('All items has been deleted.', 'success');
            this.list();
          }
        },
        deleteSelected(){

          
          for(var i = 0; i < this.items_selected.length; i++) {
            axios.delete('/api/transfers/delete/'+this.items_selected[i].id).then(response=>{
                
                //console.log(finished);
                this.list();
            }).catch(error=>{
                
                flash(JSON.parse(error.request.response).message, 'error');
            });
          }

          flash('Selected items has been deleted.', 'success');
          this.items_selected = [];

        },
        deleteTransfer(e,index,id) {
            if(confirm("Are you sure to delete transfer?")){
                $("a#delete_"+id).attr("disabled", true);
                $('a#delete_'+id).html('<i class="fas fa-spinner fa-pulse  text-secondary"></i>');
                axios.delete('api/transfers/delete/'+id).then(response=>{
                  flash(response.data.message, 'success');
                  this.list();
                  $('a#delete_'+id).html('<i class="fas fa-times-circle text-secondary"></i>').attr("disabled", false);
                }).catch(error=>{
                    $('a#delete_'+id).html('<i class="fas fa-times-circle text-secondary"></i>').attr("disabled", false);
                    flash('Error on deleting torrent', 'error');
                });
            } 
        },
      }
  }
</script>